
import { Options, Vue } from "vue-class-component";

@Options({
  emits: ["update:modelValue"],
  props: {
    label: {
      type: String,
      required: true,
    },
    modelValue: String,
  },
})
export default class AppInput extends Vue {
  private label = "";

  get inputId(): string {
    const match = this.label.match(/[a-z]+[a-z0-9]/gi);
    if (match === null) {
      throw new Error("Label must contain letters");
    }
    return "contract-input-" + match.join("").toLowerCase();
  }
}
